<script setup>
import {useFormField} from "../../../Registration/composables/useFormField";
import {useProcessedOptions} from "../../../Registration/composables/useProcessedOptions";
import {useI18n} from "vue-i18n";
import FieldErrorMessage from "../../../Registration/components/Fields/FieldErrorMessage.vue";

const { t } = useI18n();

const emit = defineEmits(['blur', 'input']);

const {item, group, groupId, backend} = defineProps(['item','group','groupId', 'backend']);
const {model, uniqueItemId, options, path, inputAttributes, isReadOnly, getFieldClasses, getPrefix, createBlurHandler, createInputHandler} = useFormField(item, group, groupId, (v) => v, (v) => v, backend);
const {processedOptions} = useProcessedOptions(item, options, getPrefix, isReadOnly, group, groupId);

const handleBlur = createBlurHandler(emit);
const handleInput = createInputHandler(emit);

const className = getFieldClasses('form-item-input text-field');

</script>

<template>
    <div :class="className">
        <label :for="uniqueItemId">
            {{ item.label }}
            <span v-if="item.required && !isReadOnly"> *</span>
        </label>
        <select :id="uniqueItemId"
                v-model="model"
                class="form-item form-element"
                v-bind="inputAttributes"
                @blur="handleBlur"
                @change="handleInput"
        >
            <option disabled :value="null">{{ t('centerstage.ui.common.input.select-placeholder') }}</option>
            <option v-for="option in processedOptions"
                    :key="option.key"
                    :value="option.key"
                    :disabled="option.disabled">
                {{ option.displayLabel }}
            </option>
        </select>
        <FieldErrorMessage :path="path" :backend="backend" />
    </div>
</template>

<style scoped>
.is-readonly select {
    opacity: 0.5;
    pointer-events: none;
    background-color: #f8f9fa;
    cursor: not-allowed;
}
</style>
